export default __webpack_public_path__ + "static/media/dropmark.71bac66b.svg";